var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikebutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#E84128"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 22,
    height: 22,
    fill: "url(#pattern0_64_6604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_64_6604",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_64_6604",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_64_6604",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADsUlEQVR4nO3cSWxNURzH8YOixhBBzCHsTBERw9ICoRWRSMQaCyIshIiNBdGYV5p2IyoEMUREqKHmISGGBa1IsWBJq0iq5Ssn74ghHbz2TPfe/yd5m6Z59/x/r73v3v895yglhBBCCCGEEEIIIdoF9AeKgb3AZeAt8JGcBuAdcBXYBxQBvWzHCvQ2770fuAa8N8fGjOUNUAnsMb/XLzEfLTAHOAp8JT/1QBkw1sIYxgHlwKc8x/AFOALMUrECpgJVdN43oBQY0YExjDQfln6PzroCTFaxALoDJUAzdn0ElucxjhVAneUxNAE7gAK3KbZf3FDgLm4dBgrbGEMhUOF4DLeBwX7T/V3gGOAlftwABrYwhoHATU9jqAFG+w55iMeQf3kMDPgn5Kf4VePtL9uck12fLtr6Fy40rzuEcdPLOdt88YVUbl4hbXcd8iTzTZx1TcAUl0HbuE5Oi8uuQp4ZurIIzXYRtL6tFn+rcNEgyrd3kQWfgb42g14cuqKILbQZtG51ipbtthm07ieLll20GfTrVg4ioNZm0Pk20LOkzmbQcjfYuiabQdtuqKfJB5tB14auJmKvbAb9KHQ1EXtgM+gzoauJ2CmbQW8NXU3ENtsMel7oaiI212bQg4DvoSuKUHNLD407G/at0FVFqMpqyCbo9aGritBaF0Hr6VY/QlcWEX0qHW49aBO2nv0pciqdhGyCXmQOImCBy6C7AC8kZfSMpa7OgjZhr5agWek0ZBN0AfA8w2FX62lxzoM2YS8lu4q9hPzHuTrURMeQbngL+Y+wJ1tawpAUjcBE70GbsPWyg6zYFiRkE3TPjHwxVre1vMNX2DNSfgppBKarGAAbSa8NKhbmKuQc6XNB16ZiohfRpGxGU61+4KFipJcbmKmsSdegl5GomAFLEt63/gEsU0kAbCG5tqgkAQ6QPAdV0uh+LXCS5DgLdFNJZFa4VhK/S/ouVyWZ2QWminjpZc99VBoA/SJtq962uqoqBkCfyNbCXE/UHkod6PadDp0wcN7FZllRIffM8VDAkI95e+YXyaVfWYCQS51PE4gNuY7fLo8hl0TXifMJWOV41ZeeWrsudJ1RIDfRXW8w6KILVxS6vqiQ291Gb6tpi96Sc1rouqIEDAMeWgj5CTAqdD1JuLE50YmQj6fmltrTFcmmPLfh1A37nZm+sugoYL5eAvwfIdd7nROXRsCEdnZsfAaMDz3OVCC3e+Qa4J55+Kv3eb5vftYj9PiEEEIIIYQQQgghVMb8BED6KuH3icwfAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikebutton);
export default __webpack_public_path__ + "static/media/likebutton.d59ed205452c5de1cc6bb897f49cebea.svg";
export { ForwardRef as ReactComponent };